module.exports = __webpack_public_path__ + "img/375.143c84cb.jpg";